import { coreApi } from '.';
import { TAG_TYPES } from 'types/services';
import type { NotificationCountResponse, SetNotificationReadStateRequest } from 'types';

export const notificationService = coreApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getNotificationCount: builder.query<NotificationCountResponse, string>({
      query: (id) => ({
        url: `Notifications/${id}/Count`,
        method: 'GET',
      }),
      providesTags: [TAG_TYPES.NOTIFICATIONS],
    }),
    editNotificationReadState: builder.mutation<void, SetNotificationReadStateRequest>({
      query: (body) => ({
        url: 'Notifications/ReadState',
        method: 'PUT',
        body,
      }),
      invalidatesTags: [TAG_TYPES.NOTIFICATIONS, TAG_TYPES.USER_NOTIFICATIONS],
    }),
  }),
});
export const { useEditNotificationReadStateMutation } = notificationService;
